import React from 'react';
import FilterToggles from '@/components/buttons/FilterToggles';
import { ATTACHMENT_TYPE } from '../constants';

const DatasetAttachmentsFilterToggles = ({ onClick, typeFilter }) => (
  <FilterToggles filters={Object.values(ATTACHMENT_TYPE).map(({ name, icon }) => ({
    active: !!typeFilter[name],
    icon,
    key: `dataset_attachment_filter_type_${name}`,
    messageId: `dataset.attachment.filter.type.${name}`,
    onClick: () => onClick({ attachmentType: name }),
  }))}
  />
);

export default DatasetAttachmentsFilterToggles;
